
import React from 'react';
import { motion } from 'framer-motion';
import SpotlightCard from './SpotlightCard';
import { Target, Zap, ShieldCheck, ArrowRight } from 'lucide-react'; // Added ArrowRight
import { Link } from 'react-router-dom';
import './About.css';

const About = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1 }
    }
  };

  return (
    <section id="about" className="about section">
      <div className="container">
        <div className="about-header">
          <motion.h6
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            className="section-subtitle"
          >
            Nossa Trajetória
          </motion.h6>
          <motion.h2
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
            className="section-title"
          >
            25 Anos Definindo o Futuro da Tecnologia
          </motion.h2>
        </div>

        <motion.div
          className="about-bento-grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-50px" }}
        >
          {/* Main Story Block */}
          <div className="bento-item bento-large">
            <SpotlightCard className="h-full">
              <div className="bento-content">
                <div>
                  <div className="mb-6 inline-flex p-3 rounded-full bg-red-50 text-red-600">
                    <Target size={32} color="var(--primary-red)" />
                  </div>
                  <h3 className="about-title">Mais que fornecedores,<br />somos parceiros.</h3>
                  <p className="about-description mt-4">
                    O seu objetivo é o nosso. Caminhamos na mesma direção com transparência e responsabilidade,
                    utilizando uma metodologia consultiva para oferecer sempre a melhor solução.
                  </p>
                </div>
                <div className="bento-decoration"></div>
              </div>
            </SpotlightCard>
          </div>

          {/* Stat/Innovation Block */}
          <div className="bento-item">
            <SpotlightCard className="h-full">
              <div className="bento-content">
                <div className="mb-4">
                  <Zap size={32} color="var(--primary-black)" />
                </div>
                <h4 className="text-2xl font-bold mb-2">Inovação Constante</h4>
                <p className="about-description text-sm">
                  Desenvolvendo soluções que otimizam o investimento e maximizam resultados.
                </p>
              </div>
            </SpotlightCard>
          </div>

          {/* Feature Block */}
          <div className="bento-item">
            <SpotlightCard className="h-full">
              <div className="bento-content">
                <div className="mb-4">
                  <ShieldCheck size={32} color="var(--primary-black)" />
                </div>
                <h4 className="text-2xl font-bold mb-2">Segurança & Confiança</h4>
                <p className="about-description text-sm">
                  Infraestrutura robusta espalhada por mais de 1.900 localidades.
                </p>
              </div>
            </SpotlightCard>
          </div>

          {/* Call to Action Block */}
          <div className="bento-item bento-large">
            <SpotlightCard className="h-full" spotlightColor="rgba(0,0,0,0.1)">
              <div className="bento-content flex flex-col md:flex-row items-center justify-between gap-6 md:gap-0">
                <div className="text-center md:text-left">
                  <h3 className="text-2xl font-bold mb-2">Pronto para transformar sua empresa?</h3>
                  <p className="about-description">Agende uma reunião hoje mesmo.</p>
                </div>
                <Link to="/contato" className="btn btn-primary" style={{ borderRadius: '50px' }}>
                  Fale Conosco <ArrowRight size={18} style={{ marginLeft: 8, display: 'inline' }} />
                </Link>
              </div>
            </SpotlightCard>
          </div>

        </motion.div>
      </div>
    </section>
  );
};

export default About;
